import {Component, Input, OnInit} from '@angular/core';
import {ProductChangeCategory} from '../../shared/model/product-change';
import {ChangeCategoryPipe} from '../../shared/pipes/change-category.pipe';
import {MatChipSet, MatChip} from '@angular/material/chips';
import {NgClass, NgOptimizedImage} from '@angular/common';


@Component({
    selector: 'myupdates-change-categories',
    templateUrl: './change-categories.component.html',
    styleUrls: ['./change-categories.component.scss'],
    imports: [NgClass, MatChipSet, MatChip, NgOptimizedImage, ChangeCategoryPipe]
})
export class ChangeCategoriesComponent implements OnInit {

  @Input() set changeCategories(categories: string[]) {
    this.changeCategoriesFilteredAndSorted = this.filterAndSortChangeCategories(categories);
  }
  @Input() verticalOrientation = false;
  changeCategoriesFilteredAndSorted: string[] = [];
  categoryValues = ProductChangeCategory.values;

  // intentionally empty
  ngOnInit(): void {} // NOSONAR

  private filterAndSortChangeCategories(changeCategories: string[]): string[] {
    return changeCategories
        .filter((value, index, array) => {
          if (!ProductChangeCategory.order.includes(value.toLowerCase())) {
            return false;
          }
          return array.indexOf(value) === index;
        })
        .sort((a: string, b: string) => {
          const aLowerCase = a.toLowerCase();
          const bLowerCase = b.toLowerCase();

          if (aLowerCase === bLowerCase) {
            return 0;
          }
          if (!ProductChangeCategory.order.includes(aLowerCase)) {
            return 1;
          }
          if (!ProductChangeCategory.order.includes(bLowerCase)) {
            return -1;
          }
          return ProductChangeCategory.order.indexOf(aLowerCase) - ProductChangeCategory.order.indexOf(bLowerCase);
        });
  }
}
